import { convertGraphQLVarsToRestParams as ceConvertGraphQLVarsToRestParams } from '~/work_items/list/graphql/rest/rest_filter_params_mapper';

// eslint-disable-next-line @gitlab/require-i18n-strings
const WILDCARD_MAP = { ANY: 'Any', NONE: 'None', UPCOMING: 'Upcoming', STARTED: 'Started' };

function appendParam(params, key, value) {
  if (value === null || value === undefined) return;
  if (Array.isArray(value)) {
    value.forEach((v) => {
      if (v !== null && v !== undefined) params.append(`${key}[]`, v);
    });
  } else {
    params.append(key, value);
  }
}

export function convertGraphQLVarsToRestParams(vars) {
  const params = ceConvertGraphQLVarsToRestParams(vars);

  appendParam(params, 'weight', vars.weight);
  appendParam(params, 'weight_wildcard_id', WILDCARD_MAP[vars.weightWildcardId]);
  appendParam(params, 'health_status', vars.healthStatusFilter);
  appendParam(params, 'iteration_id', vars.iterationId);
  appendParam(params, 'iteration_wildcard_id', WILDCARD_MAP[vars.iterationWildcardId]);
  appendParam(params, 'iteration_cadence_id', vars.iterationCadenceId);

  if (vars.status) {
    if (vars.status.id) {
      params.append('status[id]', vars.status.id);
    }
    if (vars.status.name) {
      params.append('status[name]', vars.status.name);
    }
  }

  if (vars.customField?.length) {
    vars.customField.forEach((field) => {
      if (field.fieldId && field.values) {
        field.values.forEach((value) => {
          params.append('custom_fields[]', `${field.fieldId}:${value}`);
        });
      }
    });
  }

  return params;
}
